const form = {
  formId: "add-time-to-all-form",
  formField: {
    hours: {
      name: "hours",
      label: "Playing Hours",
      type: "number",
      errorMsg: "Playing hours is required.",
      invalidMsg: "Must be greater than or equal to 0",
    },
    is_free: {
      name: "is_free",
      label: "Gift Free Time?",
      type: "checkbox",
    },
    is_late_night: {
      name: "is_late_night",
      label: "Is Late Night?",
      type: "checkbox",
    },
    players: {
      name: "players",
      label: "Select Players",
      type: "array", // Represents multiple selections (checkboxes)
      errorMsg: "At least one player must be selected.",
    },
  },
};

export default form;
